import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanBEApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  userName: string;
  firstName: string;
  epcId: string;
  emailAddress: string;
  nric: string;
  passportNumber: string;
  dateOfBirth: string;
  suspended: string;
  joinedDate: string;
  updatedAt?: string;
  subscription?: string;
}

// edit api call
const fetchMemberDetails = async (epcId: string): Promise<any> => {
  if (!epcId) {
    return null;
  }
  const response: any = await eramanBEApi.get(`/admin/epc/get?epcId=${epcId}`);
  return response.data;
};

const useMemberDocumentDetails = (
  epcId: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["memberDocumentDetails", epcId],
      enabled: false,
      queryFn: () => {
        return fetchMemberDetails(epcId);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useMemberDocumentDetails };
